export type UTM = {
  source: string | null
  medium: string | null
  campaign: string | null
}

function load(model?: Partial<UTM> | null): UTM {
  return {
    source: model?.source ?? null,
    medium: model?.medium ?? null,
    campaign: model?.campaign ?? null,
  }
}

export const getUTMComments = (model?: UTM | null) => {
  const description = model
    ? Object.entries(model)
        .map((e) => (e[1] ? `${e[0]}: ${e[1]}` : undefined))
        .filter(Boolean)
        .join(', ')
        .trim()
    : undefined
  if (description) return `UTM: [${description}]`
}

export const UTM = {
  load,
  getUTMComments,
}
